import { register, defineRelation, Direction } from 'olympe';
import InspectionEntity from './InspectionEntity.js';
import Inspection from "./Inspection";

/**
 * @extends {InspectionEntity}
 */
export default class Component extends InspectionEntity { /* empty */ }

// Hardcoded tags
register('01880fd1d68ff4844d12', Component);
Component.subComponentsRel = defineRelation('01880fd4012ee3c02553', Component, Component);
Component.inspectionsRel = defineRelation('01880fdb9f9192dd0b02', Component, Inspection);
Component.inverse_systemcomponentsRel = defineRelation('01880fd3ceeeeba6273b', Direction.ORIGIN);
Component.inverse_componentsubComponentsRel = defineRelation('01880fd4012ee3c02553', Direction.ORIGIN);
Component.inverse_systemall_componentsRel = defineRelation('01898d9703ac827a5305', Direction.ORIGIN);
